const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

type GtagCommand = "config" | "event" | "js";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (command: GtagCommand, target: string | Date, params?: Record<string, unknown>) => void;
  }
}

export const isAnalyticsEnabled = Boolean(measurementId);

export const initializeAnalytics = () => {
  if (!measurementId || typeof window === "undefined" || window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(
    _command: GtagCommand,
    _target: string | Date,
    _params?: Record<string, unknown>,
  ) {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.lootkaAnalytics = "true";
  document.head.appendChild(script);
};

export const trackPageView = (path: string) => {
  if (!measurementId || !window.gtag) return;

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: path,
  });
};

export const trackEvent = (name: string, params: Record<string, unknown> = {}) => {
  if (!measurementId || !window.gtag) return;
  window.gtag("event", name, params);
};

export {};
